import { SolicitudRecaudosComponent } from '../components/asuntos-internos/recuperacion-de-fondos-cuentas-externas/solicitud-recaudos/solicitud-recaudos.component';
import { SolicitudReintegroComponent } from '../components/asuntos-internos/recuperacion-de-fondos-cuentas-externas/solicitud-reintegro/solicitud-reintegro.component';

export const COMPONENTS = [
  {
    name: 'Solicitud de recaudos',
    value: 'SolicitudRecaudos',
    component: SolicitudRecaudosComponent,
    caso: 'Recuperación de fondos: cuenta externa',
  },
  {
    name: 'Solicitud de reintegro',
    value: 'SolicitudReintegro',
    component: SolicitudReintegroComponent,
    caso: 'Recuperación de fondos: cuenta externa',
  },
];
